var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "File_uploader",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_24_icon_container",
    "data-name": "24 icon container",
    width: 24,
    height: 24,
    fill: "#1791ea",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10897",
    "data-name": "Group 10897",
    transform: "translate(4 3.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M-1000.536,2131.423a.6.6,0,0,1-.6-.6v-1.615h-9.649v10.542h1.061v1.168h-1.769c-.595,0-.494-.837-.494-1.168v-11.142a.6.6,0,0,1,.6-.6h10.851a.6.6,0,0,1,.6.6v2.215A.6.6,0,0,1-1000.536,2131.423Z",
    transform: "translate(1013.994 -2126.006)",
    fill: "#1791ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762-2",
    "data-name": "Path 4762",
    d: "M-1000.536,2131.108a.6.6,0,0,1-.6-.6v-1.3h-9.649v10.542h1.061v1.168h-1.769c-.595,0-.494-.837-.494-1.168v-11.142a.6.6,0,0,1,.6-.6h10.851a.6.6,0,0,1,.6.6v1.9A.6.6,0,0,1-1000.536,2131.108Z",
    transform: "translate(1011.994 -2128.006)",
    fill: "#1791ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M1.614,14.034a.6.6,0,0,1-.6-.6V1.807a.6.6,0,0,1,.6-.6h10.85a.6.6,0,0,1,.6.6V13.432a.6.6,0,0,1-.6.6Zm.6-7.419v6.217h9.649V2.408H2.214V6.615Z",
    transform: "translate(2.994 3.197)",
    fill: "#1791ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M0,8.456V7.21H7.1V8.456ZM2.865,5.9V2.419L.881,4.4,0,3.523,3.523,0,7.045,3.523l-.88.88L4.11,2.348V5.9Z",
    transform: "translate(6.649 6.456)",
    fill: "#1791ea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploader);
export default __webpack_public_path__ + "static/media/File_uploader.8cb8f53a.svg";
export { ForwardRef as ReactComponent };